import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {

  transform(value: number, option: string = 'MB', roundTo: number = 2): string {
    let returnValue: string = null;
    if (value) {
      switch (option) {
        case "MB":
          const megaBytes = value / (1024*1024);
          returnValue = roundTo ? megaBytes.toFixed(roundTo) : megaBytes.toString();
      }
    }
    return returnValue ? returnValue?.concat(' ', option) : returnValue;
  }

}
